module.exports = __webpack_public_path__ + "media/images/icons/outlined/exclamation-circle-cdf661c588c51448382af0fd5086669e.svg";